import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import UserDetailsForm from "../../../components/forms/setup/users/UserDetailsForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function UsersViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const showSnackbar = (message, type) => {
    addSnackbar(
      new SnackbarData(generateUniqueNumber(), message, type)
    );
  };

  const getUsers = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `users?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setUsers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createUser = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("users/create", payload);

    if (callResult.success) {
      showSnackbar("User added", SnackbarType.Success);
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getUsers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showSnackbar(
          callResult.data?.message || "Failed to add user",
          SnackbarType.Error
        );
      }
    }
  };

  const updateUser = async function (values, index) {
    let callResult = await makePutApiCall(`users/${values.id}`, values);

    if (callResult.success) {
      showSnackbar("User updated", SnackbarType.Success);
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...users.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setUsers({ ...users, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showSnackbar(
          callResult.data?.message || "Failed to update user",
          SnackbarType.Error
        );
      }
    }
  };

  const resetPassword = async function (values, index) {
    let callResult = await makePutApiCall(
      `updatePassword/${values.id}`,
      values
    );

    if (callResult.success) {
      showSnackbar("User updated", SnackbarType.Success);
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...users.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setUsers({ ...users, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showSnackbar(
          callResult.data?.message || "Failed to update password",
          SnackbarType.Error
        );
      }
    }
  };

  const openAddUserslideOver = (isEdit, user, index) => {
    setSlideOver({
      childComponent: (
        <UserDetailsForm
          user={user}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateUser(payload, index) : createUser(payload)
          }
          resetPassword={resetPassword}
          title={isEdit ? `Update ${user.name}` : "Add new user"}
        />
      ),
      open: true,
    });
  };

  const deleteUser = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteUser/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = users.data.filter((item) => item.id !== id);
      setUsers({ ...users, data: newItems });

      showSnackbar(callResult.data.message, SnackbarType.Success);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showSnackbar(
          callResult.data?.message || "Failed to delete user",
          SnackbarType.Error
        );
      }
    }
  };

  const askDeleteUser = function (user, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteUser(user.id, index)}
          message={`Are you sure you want to delete  ${user.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddUserslideOver,
    getUsers,
    loading,
    users,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteUser,
  };
}
